import Vue from "vue";
import i18n from "@/i18n";
import BoostrapVue from "bootstrap-vue";

Vue.use(BoostrapVue, {
    "BFormDatepicker": {
        "selectedVariant": null,
        "todayVariant": null,
        "navButtonVariant": null,
        "labelPrevDecade": null,
        "labelPrevYear": i18n.t('Previous year'),
        "labelPrevMonth": i18n.t('Previous month'),
        "labelCurrentMonth": i18n.t('Current month'),
        "labelNextMonth": i18n.t('Next month'),
        "labelNextYear": i18n.t('Next year'),
        "labelNextDecade": null,
        "labelToday": i18n.t('Today'),
        "labelSelected": null,
        "labelNoDateSelected": i18n.t("No date selected"),
        "labelCalendar": null,
        "labelNav": null,
        "labelHelp": i18n.t('Use cursor keys to navigate calendar dates'),
        "labelTodayButton": i18n.t("Select today"),
        "labelResetButton": i18n.t("Reset"),
        "labelCloseButton": i18n.t("Close")
    }
});
